export const i18nConstants = {
    CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
    LABELS_FETCHED: 'LABELS_FETCHED',
    LABEL_SAVED: 'LABEL_SAVED',
    SET_LABEL_EDIT_MODE: 'SET_LABEL_EDIT_MODE',
    SET_EDITING_LABEL_KEY: 'SET_EDITING_LABEL_KEY'
};

// Single source of truth for the languages the app actually exposes in its UI:
// the LanguageSwitcher options and the only languages shown in the live label
// editor. ru is bundled for reading/seeding but is intentionally not offered here.
export const UI_LANGUAGES: { code: string; name: string }[] = [
    { code: 'en', name: 'EN' },
    { code: 'lv', name: 'LV' }
];

// Just the codes, derived from UI_LANGUAGES (never a second hardcoded list).
export const UI_LANGUAGE_CODES: string[] = UI_LANGUAGES.map(lang => lang.code);
